import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';
import { MappingService } from '../services/mapping.service';

@Pipe({
    name: 'caseTableCellMapper',
    standalone: true,
    pure: false, // ensures `.transform` is called on every CD cycle
})
export class CaseTableCellMapperPipe implements PipeTransform {
    private _cdr = inject(ChangeDetectorRef);
    private _mappingService = inject(MappingService);

    private _cachedValues = new Map<string, string>();

    transform(dataSource: any, mapping: any): string {
        const key = this.generateCacheKey(dataSource, mapping);

        if (this._cachedValues.has(key)) {
            return this._cachedValues.get(key) as string;
        }

        const initialValue = '';
        this._cachedValues.set(key, initialValue);
        this.fetchAndUpdateValue(dataSource, mapping, key);

        return initialValue;
    }

    private fetchAndUpdateValue(dataSource: any, mapping: any, key: string): void {
        this._mappingService.updateValue(dataSource, mapping).then((finalValue) => {
            this._cachedValues.set(key, finalValue);
            this._cdr.markForCheck(); // Trigger change detection
        });
    }

    /**
     * @description Generates a unique key per case table cell.
     * combine row unique identifier (taskId or cid) with the cell unique identifier -
     * mapping path (mapping) and mapping type.
     * @param dataSource table row item ({caseInstance, taskInstance?, taskInstances?})
     * @param mappingConfig mapping configuration for the cell
     * @returns
     */
    private generateCacheKey(dataSource: any, mappingConfig: any): string {
        // to handle "mergeTasksByCase = true", fallback to `caseInstance.cid`
        const firstPart = dataSource?.taskInstance?.taskId || dataSource?.caseInstance?.cid;
        return `${firstPart}:${mappingConfig.mappingType}:${mappingConfig.mapping}`;
    }
}
